export default{
    redirect:"list/realTimeForm",
    path:"/list",
    component:()=>import("@pages/list"),
    name:"list",
    children:[
        {
            path:"all",
            component:()=>import("@pages/all"),
            name:"all",
        },
        {
            path:"realTimeForm",//实时-表格
            component:()=>import("@pages/realTimeForm"),
            name:"realTimeForm",
        },
        {
            path:"realTimeChart",//实时-图表
            component:()=>import("@pages/realTimeChart"),
            name:"realTimeChart",
        },
        {
            path:"historyForm",//历史-表格
            component:()=>import("@pages/historyForm"),
            name:"historyForm",
        },
        {
            path:"historyChart",//历史-图表
            component:()=>import("@pages/historyChart"),
            name:"historyChart",
        },
        {
            path:"expenseReport",//报表--费用报表
            component:()=>import("@pages/expenseReport"),
            name:"expenseReport",
        },
        {
            path:"shiftReport",//报表--班次报表
            component:()=>import("@pages/shiftReport"),
            name:"shiftReport",
        },
        {
            path:"intervalReport",//报表--区间报表
            component:()=>import("@pages/intervalReport"),
            name:"intervalReport",
        },
        {
            path:"police",
            component:()=>import("@pages/police"),
            name:"police",
        },
        {
            path:"mapShow", //二维地图页面
            component:()=>import("@pages/mapShow"),
            name:"mapShow",
        },
        {
            path:"mapShow3D", //三维地图页面
            component:()=>import("@pages/mapShow3D"),
            name:"mapShow3D",
        },
        {
            path:"Inspection",
            component:()=>import("@pages/Inspection"),
            name:"Inspection",
        }
        ,
        {
            path:"change",
            component:()=>import("@pages/change"),
            name:"change",
        },

        /**管径分析 */
        {
            path:"diameter", // 管径分析
            component:()=>import("@pages/decision/diameter"),
            name:"diameter",
        },
        {
            path:"heat", // 保温分析
            component:()=>import("@pages/decision/heat"),
            name:"heat",
        },
        /**管段数据 */
        {
            path:"pphistory", // 管段历史数据
            component:()=>import("@pages/pipelinedata/pphistory"),
            name:"pphistory",
        },
        {
            path:"ppalarm", // 管段报警列表
            component:()=>import("@pages/pipelinedata/ppalarm"),
            name:"ppalarm",
        },
        {
            path:"ppcurve", // 管段历史曲线
            component:()=>import("@pages/pipelinedata/ppcurve"),
            name:"ppcurve",
        },
        /**流程图 */
        {
            path:"flow",
            component:()=>import("@pages/flowDiagram"),
            name:"flow",
        },
        /**工程图 */
        {
            path:"drawings", 
            component:()=>import("@pages/drawings"),
            name:"drawings",
        },
        /**管道故障图 */
        {
            path:"fault", 
            component:()=>import("@pages/fault"),
            name:"fault",
        },
        /** grapheditor */
        {
            path:"grapheditor",
            component:()=>import("@pages/grapheditor"),
            name:"grapheditor",
        },
        /**系统设置 */
        {
            path:"userinfo", 
            component:()=>import("@pages/systemsetting/userinfo"),
            name:"userinfo",
        },
        /**计费系统 */
        {
            path:"billing",
            component:()=>import("@pages/billing"),
            name:"billing",
        },
        /** 用气申报 */
        {
            path:"gas",
            component:()=>import("@pages/gas"),
            name:"gas",
        },
        /** 管道模拟计算 */
        {
            path:"simulation",
            component:()=>import("@pages/simulation"),
            name:"simulation",
        },
        
    ]
}